export default "__VITE_ASSET__DiDJBi1A__"